const projectsData = [
  {
    id: 1,
    category: "Gas",
    location: "Tamil Nadu",
    title: "Ammonia Plant",
    images: [
      "/assets/images/projects/ammonia-plant.jpg",
      "/assets/images/projects/image8.jpg",
      "/assets/images/projects/image9.jpg",
    ],
    description:
      "Industrial engineering support for a process-focused ammonia plant, planned around structural safety, coordination, and long-term operational reliability.",
  },
  {
    id: 2,
    category: "Gas",
    location: "Assam",
    title: "IOCL Assam",
    images: [
      "/assets/images/projects/IOCL-Assam.jpg",
      "/assets/images/projects/image10.jpg",
      "/assets/images/projects/image11.jpg",
    ],
    description:
      "Oil and gas infrastructure work delivered with attention to plant standards, buildability, and disciplined project coordination.",
  },
  {
    id: 3,
    category: "Building",
    location: "Angola",
    title: "PEB Shed at Angola",
    images: [
      "/assets/images/projects/04_PEB-Shed-at-Angola.jpeg",
      "/assets/images/projects/image2.jpg",
      "/assets/images/projects/image3.jpg",
    ],
    description:
      "Pre-engineered building design for a large shed structure, balancing span efficiency, durability, and construction speed.",
  },
  {
    id: 4,
    category: "Building",
    location: "Odisha",
    title: "PEB Shed at Odisha",
    images: [
      "/assets/images/projects/PEB-Shed-at-Odhisa.jpg",
      "/assets/images/projects/image4.jpg",
      "/assets/images/projects/image5.jpg",
    ],
    description:
      "A practical PEB shed solution developed for reliable site execution, efficient material usage, and resilient structural performance.",
  },
  {
    id: 5,
    category: "Estate",
    location: "Tamil Nadu",
    title: "Real Estate Project",
    images: [
      "/assets/images/projects/real-estate1.jpeg",
      "/assets/images/projects/image6.jpeg",
      "/assets/images/projects/image7.jpeg",
    ],
    description:
      "Real estate structural consulting shaped for residential and commercial needs, with a focus on usable planning and dependable engineering.",
  },
];

export default projectsData;